export const funFactsData = [
  {
    fact: 'Honey never spoils. Archaeologists have found pots of honey in ancient Egyptian tombs that are over 3,000 years old and still perfectly edible.',
    category: 'Food',
    submittedBy: 'System',
    submittedByEmail: 'system@sydneyferris.com',
    submittedByUid: 'system',
    status: 'approved',
    approvedAt: '2024-01-01T00:00:00.000Z'
  },
  {
    fact: 'The shortest war in history was between Britain and Zanzibar in 1896. Zanzibar surrendered after 38 minutes.',
    category: 'History',
    submittedBy: 'System',
    submittedByEmail: 'system@sydneyferris.com',
    submittedByUid: 'system',
    status: 'approved',
    approvedAt: '2024-01-01T00:00:00.000Z'
  },
  {
    fact: 'A day on Venus is longer than a year on Venus. It takes 243 Earth days to rotate once on its axis, but only 225 Earth days to orbit the Sun.',
    category: 'Science',
    submittedBy: 'System',
    submittedByEmail: 'system@sydneyferris.com',
    submittedByUid: 'system',
    status: 'approved',
    approvedAt: '2024-01-01T00:00:00.000Z'
  },
  {
    fact: 'The first computer programmer was Ada Lovelace, who wrote algorithms for Charles Babbage\'s Analytical Engine in the 1840s.',
    category: 'Technology',
    submittedBy: 'System',
    submittedByEmail: 'system@sydneyferris.com',
    submittedByUid: 'system',
    status: 'approved',
    approvedAt: '2024-01-01T00:00:00.000Z'
  },
  {
    fact: 'Octopuses have three hearts and blue blood. Two hearts pump blood to the gills, while the third pumps it to the rest of the body.',
    category: 'Nature',
    submittedBy: 'System',
    submittedByEmail: 'sydferris@gmail.com',
    submittedByUid: 'system',
    status: 'approved',
    approvedAt: '2024-01-01T00:00:00.000Z'
  }
];
